import { getInfo, getChosenDate, getChosenFacility, getChosenService, getChosenAddons } from '../general.js';

export default async function showBodelForm() {
    const info = getInfo();
    const service = getChosenService();
    const addons = getChosenAddons();
    const facility = getChosenFacility();

    let services = service.name;
    if(addons.length > 0) {
        addons.forEach(addon => {
            services += ', ' + addon.title;
        })
    }

    document.querySelector('input[type="hidden"][data-prefill="regnummer"]').value = info.regno;
    document.querySelector('input[type="hidden"][data-prefill="modell"]').value = info.model;
    document.querySelector('input[type="hidden"][data-prefill="marke"]').value = info.brand;
    document.querySelector('input[type="hidden"][data-prefill="verkstad"]').value = facility.title;
    document.querySelector('input[type="hidden"][data-prefill="datum"]').value = getChosenDate();
    document.querySelector('input[type="hidden"][data-prefill="tjanster"]').value = services;

    // const form = new FormData();
    // form.append('action', 'nobox_show_bodel_form');
    // form.append('regno', );
    // form.append('model', );
    // form.append('brand', brand);
    // form.append('facility', );
    // form.append('service', );
    // form.append('time', );


    // const params = new URLSearchParams(form);

    // await fetch(horizon.ajaxUrl, {
    //     method: 'POST',
    //     credentials: 'same-origin',
    //     headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         'Cache-Control': 'no-cache',
    //     },
    //     body: params
    // })
    // .then(response => response.json())
    // .then(data => {
    //     document.getElementById('bodel_target').innerHTML = data.html;
    //     console.log('written')
    // })
    // .then(() => {
    //     setTimeout(() => {
    //         window.document.dispatchEvent(new Event("DOMContentLoaded"));
    //     }, 1000)
    // })
}
